var q = Object.defineProperty, z = Object.defineProperties;
var A = Object.getOwnPropertyDescriptors;
var f = Object.getOwnPropertySymbols;
var y = Object.prototype.hasOwnProperty, g = Object.prototype.propertyIsEnumerable;
var I = (e, o, t) => o in e ? q(e, o, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[o] = t, l = (e, o) => {
  for (var t in o || (o = {}))
    y.call(o, t) && I(e, t, o[t]);
  if (f)
    for (var t of f(o))
      g.call(o, t) && I(e, t, o[t]);
  return e;
}, p = (e, o) => z(e, A(o));
var k = (e, o) => {
  var t = {};
  for (var n in e)
    y.call(e, n) && o.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && f)
    for (var n of f(e))
      o.indexOf(n) < 0 && g.call(e, n) && (t[n] = e[n]);
  return t;
};
import { jsxs as C, jsx as s } from "react/jsx-runtime";
import r from "../../../node_modules/prop-types/index.es.js";
import O, { useId as D, useEffect as G } from "react";
import * as J from "./style.es.js";
import { Input as K, InputBody as M, InputElement as Q, InputCheckmark as T, InputLabel as U } from "./style.es.js";
import { Helper as V } from "../../DataDisplay/Helper/Helper.es.js";
import { Icon as P } from "../../DataDisplay/Icon/Icon.es.js";
import { POSITION as R } from "../../../constants/position.es.js";
const h = O.forwardRef((W, w) => {
  var x = W, {
    id: e,
    name: o,
    label: t,
    defaultChecked: n = !1,
    checked: i,
    onChange: j,
    helperText: F,
    error: d = !1,
    success: b = !1,
    disabled: u = !1,
    labelPosition: S = R.right,
    indeterminate: m = !1,
    alignItems: v = "center",
    typographyProps: E = {}
  } = x, N = k(x, [
    "id",
    "name",
    "label",
    "defaultChecked",
    "checked",
    "onChange",
    "helperText",
    "error",
    "success",
    "disabled",
    "labelPosition",
    "indeterminate",
    "alignItems",
    "typographyProps"
  ]);
  const B = D(), a = e || B, [c, H] = O.useState(w), L = l({}, i ? {
    checked: i
  } : {
    defaultChecked: n
  });
  return G(() => {
    c && (c.indeterminate = m, c.checked = i);
  }, [m, i, c]), /* @__PURE__ */ C(K, { error: d, success: b, disabled: u, type: "checkbox", children: [
    /* @__PURE__ */ C(M, { labelPosition: S, alignItems: v, children: [
      /* @__PURE__ */ s(Q, p(l(l({ type: "checkbox", id: a, name: o, onChange: j, disabled: u }, L), N), { ref: H })),
      m ? /* @__PURE__ */ s(T, { htmlFor: a, children: /* @__PURE__ */ s(P, { name: "indeterminate" }) }) : /* @__PURE__ */ s(T, { htmlFor: a, children: /* @__PURE__ */ s(P, { name: "success" }) }),
      t && /* @__PURE__ */ s(U, p(l({ as: "label", htmlFor: a, variant: "body2" }, E), { children: t }))
    ] }),
    /* @__PURE__ */ s(V, { text: F, error: d, success: b })
  ] });
});
h.S = J;
h.displayName = "Checkbox";
h.propTypes = {
  id: r.string,
  name: r.string,
  label: r.oneOfType([r.string, r.node]),
  defaultChecked: r.bool,
  onChange: r.func,
  helperText: r.string,
  error: r.bool,
  success: r.bool,
  indeterminate: r.bool,
  labelPosition: r.oneOf(Object.values(R)),
  alignItems: r.oneOf(["center", "flex-start", "flex-end"])
};
export {
  h as Checkbox
};
//# sourceMappingURL=Checkbox.es.js.map
